module.exports = __webpack_public_path__ + "img/5.6c3ae43c.png";